<template>
  <div>
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <v-card v-else>
      <v-card-title>
        {{baja.motivo.toUpperCase()}}
        <v-spacer></v-spacer>
        <v-btn class="ma-2" color="red" fab small dark @click="_cerrar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Fecha y Hora</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{
                  baja.fechaAlta | moment("dddd D [de] MMMM YYYY HH:mm")
                  }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense v-if="baja.motivo === 'intersucursal'">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Sucursal de Destino</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{
                  baja.detalles.sucursal.descripcion
                  }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Usuario</th>
                <th class="text-left">Observacion</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{
                  baja.usuario.nombre
                  }}
                </td>
                <td>
                  {{
                  baja.detalles.observacion
                  }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-divider></v-divider>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Producto</th>
                <th class="text-left">Cantidad</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in baja.productos" :key="item.name">
                <td>{{ item.producto.nombre }}</td>
                <td>{{ item.cantidad }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
const greaterThanZero = value => value > 0;
export default {
  name: "Mercaderias_Baja_Ver",
  data() {
    return {
      loading: true,
      baja: {}
    };
  },
  methods: {
    _cerrar() {
      this.$router.push(`/mercaderias`);
    }
  },
  async created() {
    try {
      const baja = await axios.get(`/mercaderia/baja/${this.id}`);
      this.baja = baja.data;
    } catch (error) {
      this.$router.push(`/mercaderias`);
    }
    this.loading = false;
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  }
};
</script>
